export enum AppPlatforms {
  ANDROID = 'android',
  IOS = 'ios',
}
